module.exports = __webpack_public_path__ + "static/media/default-avatar.7dbe0b0a.jpg";